import type { DonationDisplayStatus } from '@signalvote/shared';
import { donationStatusLabel } from '@signalvote/shared';
import { Badge } from '@/components/ui/badge';

// Translate the wire status enum to a treasurer-facing pill at the render boundary.
// Disputed is loud (destructive), Refunded muted, Succeeded quiet. The one source of
// truth for the donation status pill — shared by the dashboard card, the "View all"
// feed, and the detail drawer so they can't drift.
//
// The WORD comes from the shared `donationStatusLabel`, which mobile's badge reads
// too: a treasurer checking one gift on a laptop and on a phone must never be told
// two different things about where it stands. Only the visual variant is web's own.
const DONATION_STATUS_VARIANT: Record<
  DonationDisplayStatus,
  'secondary' | 'outline' | 'destructive'
> = {
  Succeeded: 'secondary',
  Refunded: 'outline',
  Disputed: 'destructive',
};

export function DonationStatusBadge({
  status,
  testId = 'donation-status',
}: {
  status: DonationDisplayStatus;
  testId?: string;
}) {
  return (
    <Badge variant={DONATION_STATUS_VARIANT[status]} data-testid={testId}>
      {donationStatusLabel(status)}
    </Badge>
  );
}
